import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import SortableTable, {SortableTableColumn, SortableTableRow} from 'ui-library/SortableTable';
import {capitalize, constantCaseToWords} from 'util/NameUtil';

const {defaultColumn} = SortableTable;

interface ProjectOpenReview {
  entryName: string;
  entryURL: string;
  status: string;
  authors: Array<string>;
  auditors: Array<string>;
}

interface ProjectOpenReviewsProps {
  openReviews: Array<ProjectOpenReview>;
}

function ProjectOpenReviews({openReviews}: ProjectOpenReviewsProps): JSX.Element {
  const columns: Array<SortableTableColumn> = [
    defaultColumn('Entry Name', 'entryName', {
      render(entryNameColumn: SortableTableColumn, entryRow: SortableTableRow): JSX.Element {
        const row = entryRow as ProjectOpenReview;
        return (
          <span>
            {row.entryName}
            <a href={row.entryURL} className="u-tiny-spacing-left">
              <BenchlingIcon icon="link" />
            </a>
          </span>
        );
      },
    }),
    defaultColumn('Status', 'status', {
      transform(value: unknown): string {
        return capitalize(constantCaseToWords(value as string));
      },
    }),
    defaultColumn('Authors', 'authors'),
    defaultColumn('Auditors', 'auditors'),
  ];

  return (
    <div>
      <h4>{`Open Reviews (${openReviews.length})`}</h4>
      <SortableTable columns={columns} rows={openReviews} />
    </div>
  );
}

export default ProjectOpenReviews;
